<tlc-churn-flow-step-template [currentStep]="3" [reasonInfoboxMessage]="infoboxMessage()">
  <div class="left">
    <tlc-churn-flow-reason-template
      [heading]="'tlc.churn_flow.steps.other.heading' | translate"
      [subheading]="'tlc.churn_flow.steps.other.subheading' | translate"
      (stayWithTellent)="stayWithTellent()"
      (stillWantToCancel)="stillWantToCancel()"
    >
      <div class="solutions-container">
        <tlc-churn-flow-solution-card
          [iconVariant]="contactSpecialist.iconVariant"
          [title]="contactSpecialist.title"
          [subtitle]="contactSpecialist.subtitle"
          [incentives]="contactSpecialist.incentives"
        >
          <div class="actions">
            <rt-button variant="tertiary" (click)="contactSpecialistAction()">
              <rt-icon name="open-in-new" />
              <span>{{ contactSpecialist.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>
      </div>
    </tlc-churn-flow-reason-template>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
